import httpService from './http.service';

const fetchReceipts = (parkingPlaceId, query, state, fiscalizationState, parkingActiveId, dateFrom, dateTo) => httpService
    .get('/receipt?'+getParams(parkingPlaceId, query, state, fiscalizationState, parkingActiveId, dateFrom, dateTo))
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const forwardReceipt = (receipt, email) => httpService
    .put('/receipt/resend?email='+encodeURIComponent(email), receipt)
    .then(({data}) => data)
    .catch((err) => Promise.reject(err));

const getParams = (parkingPlaceId, query, state, fiscalizationState, parkingActiveId, dateFrom, dateTo) => {
    let result = parkingPlaceId ? 'parkingPlaceId='+parkingPlaceId:'';
    result = result + (query?(result?'&':'')+'query='+query:'');
    result = result + (state?(result?'&':'')+'state='+state:'');
    result = result + (fiscalizationState?(result?'&':'')+'fiscalizationState='+fiscalizationState:'');
    result = result + (parkingActiveId?(result?'&':'')+'parkingActiveId='+parkingActiveId:'');
    result = result + (dateFrom?(result?'&':'')+'dateFrom='+new Date(dateFrom).toISOString():'');
    result = result + (dateTo?(result?'&':'')+'dateTo='+new Date(dateTo).toISOString():'');
    return result;
}

export default {
    fetchReceipts, forwardReceipt
};